export const addExtensionListener = (callback) => {
  if (chrome) {
    chrome.runtime?.onMessage?.addListener?.(callback);
  }

  // TODO: add support in other browsers as well
};

export const removeExtensionListener = (callback) => {
  if (chrome) {
    chrome.runtime?.onMessage?.removeListener?.(callback);
  }
};

export enum ExtensionGlobalMessageTypes {
  GetSettings = "getSettings",
  CurrentSettings = "currentSettings",
  UpdateSettings = "updateSettings",
  CloseSettingsPage = "closeSettingsPage",
}

export enum ExtensionWorkerMessageTypes {
  CloseSettingsPage = "closeSettingsPage",
}

export enum ExtensionGlobalSources {
  Extension = "extension",
  WebPage = "web-page",
}

export const sendExtensionServiceWorkerMessage = (
  messageType: ExtensionWorkerMessageTypes,
  options = {},
) => {
  chrome.runtime?.sendMessage?.({ type: messageType, options });
};

export const sendExtensionMessage = (
  messageType: ExtensionGlobalMessageTypes,
  source: ExtensionGlobalSources,
  params: any = {},
) => {
  return window.postMessage(
    {
      type: "KAHUN_EXTENSION",
      payload: { messageType, source, ...params },
    },
    "*",
  );
};

export const createGlobalEventHandler = (
  event,
  originFilter: ExtensionGlobalSources,
  callback: (a: GlobalEventCallbackPrams) => void,
) => {
  if (event?.data?.type !== "KAHUN_EXTENSION") {
    return;
  }

  const { messageType, source, ...payload } = event?.data?.payload;

  if (source === originFilter) return;

  callback({
    messageType,
    source,
    payload,
  });
};

export interface GlobalEventCallbackPrams {
  messageType: ExtensionGlobalMessageTypes;
  source: ExtensionGlobalSources;
  payload: any;
}

export const addGlobalMessageExtensionListener = (callback) => {
  window.addEventListener("message", callback);
};

export const removeGlobalMessageExtensionListener = (callback) => {
  if (window) {
    window.removeEventListener("message", callback);
  }
};
